import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 px-4 bg-espresso-900 text-cream-100" data-id="element-67">
      <div className="max-w-3xl mx-auto text-center" data-id="element-68">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-69">
          <ShieldCheck className="w-16 h-16 text-gold-500 mb-4" data-id="element-70" />
          <h2 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-71">GARANTÍA</h2>
          <h3 className="text-xl text-gold-500 font-serif italic mb-4" data-id="element-72">
            Garantía de confianza de <strong data-id="element-73">30 días</strong>
          </h3>
          <p className="text-lg text-cream-200/90 leading-relaxed max-w-xl" data-id="element-74">
            Si no te gusta,{' '}
            <u className="decoration-gold-500 decoration-2 underline-offset-4" data-id="element-75">
              te devolvemos tu dinero.
            </u>
            <br data-id="element-76" />
            <span className="font-bold text-white mt-1 block" data-id="element-77">
              Sin preguntas.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}